import store from "../../redux/store/store";
import {apiLoading} from "../../redux/slice/apiSlice";
import {toast} from "sonner";
import {AxiosError} from "axios";
import {handleActiveError} from "../sonner/ToastBasic";

export const breadCrumbsDelimiter = () => {
    return " > ";
}

export const apiRequest = async (fetchMethod, success, duplicated, failure) => {
    try {
        store.dispatch(apiLoading(true));
        const response = await fetchMethod();
        if (response) {
            if (response.status === 200) {
                if (success) success(response.data);
                return response.data;
            } else if (response.status === 201) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if (response.status === 202) {
                if (duplicated) duplicated(response.data);
            }
        }
    } catch (error) {
        console.log(error);
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            if (failure) failure();
            toast.error("서버에러");
            return { status, data };
        }
    } finally {
        store.dispatch(apiLoading(false));
    }
};

export const calculateRemainingDays = (endDate) => {
    const today = new Date();
    const end = new Date(endDate);

    // 시간 제거
    today.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    // 오늘 기준 종료일까지의 시간 차이를 계산 (밀리초 단위)
    const diffTime = end - today;
    const diffDays = Math.ceil(Math.abs(diffTime) / (1000 * 60 * 60 * 24));

    // 주와 일 계산
    const weeks = Math.floor(diffDays / 7);
    const days = diffDays % 7;

    if (diffTime > 0) {
        // 종료일이 미래라면
        return `${weeks > 0 ? `${weeks}주 ` : ""}${days > 0 ? `${days}일 ` : ""}남음`.trim();
    } else if (diffTime < 0) {
        // 종료일이 과거라면
        return `${weeks > 0 ? `${weeks}주 ` : ""}${days > 0 ? `${days}일 ` : ""}지남`.trim();
    } else {
        // 오늘이 종료일이라면
        return `오늘까지`;
    }
}

export const calculateLeftDateRate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const today = new Date();

    // 시간 제거
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (today <= start) {
        // 시작일 이전이면 진행률 0%
        return 0;
    } else if (today >= end) {
        // 종료일 이후면 진행률 100%
        return 100;
    } else {
        const totalDuration = end - start; // 전체 기간 (밀리초)
        const elapsedDuration = today - start; // 경과한 기간 (밀리초)
        const progress = (elapsedDuration / totalDuration) * 100; // 퍼센트 계산
        return Math.round(progress); // 소수점 반올림
    }
}

export const getDate = (date) => {
    const converted = new Date(date);
    converted.setHours(0, 0, 0, 0);
    return converted;
}

export const handleSetUserInfo = (user) => {
    let userInfo;
    if (user) {
        if (user.department) {
            userInfo = `[ ${user.department.name} ] ${user.name}`;
        } else {
            userInfo = `${user.name}`;
        }
    }
    return userInfo;
}